module.exports = __webpack_public_path__ + "static/media/ai-fundamentals-skills-badge.1.dba7e420.png";